import Box from "@mui/material/Box";
import DocumentList from "./components/DocumentList";
import DayoffDocumentList from "./components/DayoffDocumentList";

const Documents = () => {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        marginTop: 10,
        overflowX: "auto",
        minWidth: { xs: 600, sm: 0 },
        flex: "flex",
        flexDirection: "column",
      }}
    >
      <DocumentList />
      <DayoffDocumentList />
    </Box>
  );
};

export default Documents;
